import {QueryCacheKeys} from '../../api/cache';
import {getInvoices} from '../../api/invoices';
import {getProjects} from '../../api/projects';
import {Queries} from '../../api/queries';
import Layout from '../Layout';
import {Box, Button, Icon, Link, Table} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';
import {type ReactNode} from 'react';
import {groupBy} from 'shared/src/map';

const CustomersList = () => {
	const {data: customers} = useQuery(Queries.customers());

	const {data: projects} = useQuery({
		queryKey: QueryCacheKeys.projects(),
		queryFn: () => getProjects(),
		select: (projects) => groupBy(projects, (project) => project.customer),
	});

	const {data: invoices} = useQuery({
		queryKey: QueryCacheKeys.invoices(),
		queryFn: () => getInvoices(),
		select: (invoices) => groupBy(invoices, (invoice) => invoice.customer),
	});

	return (
		<Layout>
			<Layout.Header title='Customers'>
				<Button appearance='primary' href='/customers/new'>
					<Icon name='plus' mr='space.300' />
					New Customer
				</Button>
			</Layout.Header>
			<Layout.Body>
				<Box
					width='100%'
					p='space.300'
					border='500'
					borderRadius='outer'
					borderColor='container.border.base'
					bg='white'
				>
					<Table
						head={[
							{id: 'name', content: 'Name'},
							{id: 'email', content: 'Email'},
							{id: 'phone', content: 'Phone'},
							{id: 'notes', content: 'Notes'},
							{id: 'invoices', content: 'Invoices'},
							{id: 'project', content: 'Projects'},
						]}
						rows={
							customers?.map((customer) => {
								const customerInvoices = invoices?.get(customer.id) ?? [];

								let invoiceContent: ReactNode = '–';
								if (customerInvoices.length === 1) {
									invoiceContent = <Link href={`/invoices/${customerInvoices[0].id}/edit`}>1</Link>;
								} else if (customerInvoices.length > 1) {
									invoiceContent = (
										<Link href={`/customers/${customer.id}/invoices`}>
											{customerInvoices.length}
										</Link>
									);
								}

								const customerProjects = projects?.get(customer.id) ?? [];

								let projectContent: ReactNode = '–';
								if (customerProjects.length === 1) {
									projectContent = <Link href={`/projects/${customerProjects[0].id}`}>1</Link>;
								} else if (customerProjects.length > 1) {
									projectContent = (
										<Link href={`/customers/${customer.id}/projects`}>
											{customerProjects.length}
										</Link>
									);
								}

								return {
									id: customer.id,
									cells: [
										{
											id: 'name',
											content: <Link href={`/customers/${customer.id}/edit`}>{customer.name}</Link>,
										},
										{id: 'email', content: customer.email},
										{id: 'phone', content: customer.phoneNumber},
										{id: 'notes', content: customer.notes},
										{
											id: 'invoices',
											content: invoiceContent,
										},
										{
											id: 'projects',
											content: projectContent,
										},
									],
								};
							}) ?? []
						}
					/>
				</Box>
			</Layout.Body>
		</Layout>
	);
};

export default CustomersList;
